$(function () {
    $(window).resize(function () {
        fixedMargin();
    });
    fixedMargin();
    function fixedMargin() {
        var Header = $(".header").outerHeight(true);
        $('[js-club-page-wrapper]').css('padding-top', Header);
        $('[js-trial-wrapper]').css('padding-top', Header);
    }
});